import { isEmpty } from 'lodash'

/**
 * Determines if shipping calculation should be triggered
 * @param {object} params - Shipping calculation conditions
 * @param {boolean} params.isInitializing - Whether checkout is initializing
 * @param {boolean} params.isCartLoaded - Whether cart is loaded
 * @param {object} params.checkout - Checkout state object
 * @param {object} params.portal - Portal configuration
 * @returns {boolean} - Whether shipping calculation should be triggered
 */
export const shouldCalculateShipping = ({ isInitializing, isCartLoaded, checkout, portal, isShipperHQ }) => {
  // Don't calculate during initialization or if cart isn't loaded
  if (isInitializing || !isCartLoaded) return false

  // This helper is only for the ShipperHQ flow.
  if (!isShipperHQ) return false

  const guestCheckoutEnabled = portal.checkout_mode === 'both' || portal.checkout_mode === 'guest_only'
  // since guest checkout ignores multi address shipping, we need to check if guest checkout is enabled
  if (portal.multiple_address_shipping && !checkout.multiAddressSelection.length && !guestCheckoutEnabled) return false

  // Only calculate if there's a selected customer address
  return !isEmpty(checkout?.selectedCustomerAddress)
}

/**
 * Creates parameters for shipping quote request
 * @param {object} params - Shipping calculation parameters
 * @param {object} params.checkout - Checkout state object
 * @param {Array} params.cartItems - Array of cart items
 * @returns {object} - Parameters for shipping quote request
 */
export const createShippingParams = ({ checkout, cartItems }) => ({
  selectedCustomerAddress: checkout?.selectedCustomerAddress,
  cartItems,
  multiAddressSelection: checkout?.multiAddressSelection
})
